import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
    gridContainer: {
        margin: '13em 0 17em 28% ',
        display: 'flex',
        flexDirection: 'row',
        '& #logosUnion': {
          marginLeft:'20%',
            '& img': {
                height: '95%',
                width: '95%',
            },
        },
        [theme.breakpoints.down(1200)]: {
              margin:'13em 0 17em 23%',
        },
        [theme.breakpoints.down(1001)]: {
              margin:'13em 0 17em 20%',
        },
        [theme.breakpoints.down(905)]: {
          margin:'13em 0 17em 16%',
          '& #logosUnion': {
            marginLeft:'13%',
          },
        },
        [theme.breakpoints.down(850)]: {
          margin:'13em 0 12em 16%',
        },
        [theme.breakpoints.down(701)]: {
          margin:'100px 0 80px 22%',
          '& #logosUnion': {
            alignSelf:'flex-end',
            marginLeft:'10%',
            '& img': {
                height: '55% !important',
                width: '55% !important',
                marginBottom:'0',
            },
          },
        },
        [theme.breakpoints.down(601)]: {
          margin:'100px 0 80px 20%',
        },
        [theme.breakpoints.down(550)]: {
          margin:'100px 0 80px 18%',
          '& #logosUnion': {
              marginLeft:'5%',
              '& img': {
                  width: '52% !important',
              },
          },
        },
        [theme.breakpoints.down(456)]: {
          '& #logosUnion': {
            '& img': {
                width: '55% !important',
            },
          },
        },
        [theme.breakpoints.down(440)]: {
          '& #logosUnion': {
            '& img': {
                width: '70% !important',
            },
          },
        },
        [theme.breakpoints.down(360)]: {
          '& #logosUnion': {
            '& img': {
                width: '75% !important',
            },
          },
        },
        [theme.breakpoints.down(350)]: {
          '& #logosUnion': {
              marginLeft:'3%',
            width: '30% !important',
            '& img': {
                width: '95% !important',
            },
          },
        },
    },
    textContainer: {
        width: '50%',
        [theme.breakpoints.down(905)]: {
          width: '55%',
        },
        [theme.breakpoints.down(550)]: {
          width: '60%',
        },
        [theme.breakpoints.down(450)]: {
          width: '100%',
        },
    },
    subtitle: {
        fontSize: '36px',
        color: theme.palette.primary.main,
        letterSpacing: '3.21px',
        lineHeight: '50px',
        fontWeight: 500,
        marginBottom: '104px',
        '& span': {
            fontWeight: 900,
        },
        [theme.breakpoints.down(1200)]: {
            marginBottom: '70px',
        },
        [theme.breakpoints.down(1001)]: {
            fontSize: '31px',
            lineHeight: '45px',
        },
        [theme.breakpoints.down(850)]: {
            marginBottom: '50px',
        },
        [theme.breakpoints.down(701)]: {
          marginBottom: '55px',
          fontSize: '26px',
          lineHeight: '35px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '23px',
          lineHeight: '30px',
          marginBottom: '45px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '21px',
          lineHeight: '27px',
          marginBottom: '45px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '19px',
          lineHeight: '25px',
        },
    },
    subSectionIndex: {
        fontWeight: 900,
        fontSize: '18.31px',
        color: theme.palette.primary.section,
        flexDirection: 'column',
        marginBottom: '80px',
        letterSpacing: '1.71px',
        lineHeight: '29px',
        [theme.breakpoints.down(1200)]: {
            marginBottom: '70px',
        },
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(850)]: {
            marginBottom: '50px',
        },
        [theme.breakpoints.down(701)]: {
          marginBottom: '32px',
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          marginBottom: '28px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
          marginBottom: '25px',
        },
    },
    text: {
        fontSize: '18.3px',
        color: theme.palette.primary.main,
        letterSpacing: '0.7px',
        lineHeight: '26.35px',
        fontWeight: 500,
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '21px',
          marginBottom:'0',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
});
